import { NavLink, Outlet } from "react-router-dom";

import { RouteErrorBoundary } from "@/components/feedback";
import { ThemeToggle } from "@/features/theme/ThemeToggle";
import { cn } from "@/lib/utils";

/**
 * Layout de campo — usado por `/kiosk`, `/mediator`, `/participant` e
 * `/exhibitor`: telas operacionais/públicas (totem de recepção, telão de
 * palco, tablets de expositor/participante), hoje com navegação própria e
 * mais simples que o painel do organizador.
 *
 * Porte do `mountNav`/`NAV` de `app/web/app.js` (topo simples com marca +
 * links — não confundir com o `NAV` do painel em `app/web/js/app.js`, que é
 * a sidebar). Aqui reproduzimos com o novo design system, mas com alvos de
 * toque maiores (padding generoso) e alto contraste (item ativo em cor
 * sólida), já que estas telas rodam em tablet/totem/telão, não numa mesa de
 * escritório.
 */
const FIELD_NAV = [
  { href: "/visao-geral", label: "Painel" },
  { href: "/kiosk", label: "Check-in" },
  { href: "/atendimento", label: "Atendimento" },
  { href: "/exhibitor", label: "Expositor" },
  { href: "/participant", label: "Participante" },
];

export function FieldLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="flex flex-wrap items-center gap-2 border-b border-border-strong bg-surface px-4 py-3 shadow-sm">
        <div className="flex items-center gap-2 pr-3 text-base font-bold text-fg">
          <span className="grid size-8 shrink-0 place-items-center rounded-[9px] bg-primary text-sm font-extrabold text-primary-foreground">
            E
          </span>
          <span className="hidden sm:inline">EVENTOS.AI</span>
        </div>

        <nav className="flex flex-1 flex-wrap gap-1" aria-label="Navegação de campo">
          {FIELD_NAV.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                cn(
                  "rounded-md px-4 py-2.5 text-sm font-semibold text-fg-soft transition-colors hover:bg-accent-weak hover:text-fg",
                  isActive &&
                    "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground",
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <ThemeToggle />
      </header>

      <main className="flex-1 p-4 sm:p-6">
        <RouteErrorBoundary>
          <Outlet />
        </RouteErrorBoundary>
      </main>
    </div>
  );
}
